/**
 * Service Icon Map — Pass 2.4 app parity.
 * Maps service slugs/IDs to app-style red monochrome PNG icons.
 * Aliases match the FixomeMobile serviceIcons.js mapping.
 */

const SERVICE_ICONS = {
  'plumbing': '/services/icon_plumbing.png',
  
  'electrical': '/services/icon_electrical.png',
  
  'ac-repair': '/services/icon_ac_repair.png',
  'ac-technicians': '/services/icon_ac_repair.png',
  
  'deep-cleaning': '/services/icon_deep_cleaning.png',
  
  'moving': '/services/icon_moving.png',
  'movers': '/services/icon_moving.png',
  
  'painting': '/services/icon_painting.png',
  
  'pest-control': '/services/icon_pest_control.png',
  
  'appliance-repair-and-service': '/services/icon_appliances.png',
  'home-appliances': '/services/icon_appliances.png',
  'appliance-repair': '/services/icon_appliances.png',
};

/**
 * Get the icon URL for a service by slug/ID.
 * Falls back to plumbing icon if no match.
 * @param {Object|string} service - Service object or slug string
 * @returns {string} Icon URL
 */
export function getServiceIconUrl(service) {
  const slug = typeof service === 'string'
    ? service.toLowerCase()
    : String(service?.slug || service?.id || service?.name || '').toLowerCase();
  
  if (SERVICE_ICONS[slug]) {
    return SERVICE_ICONS[slug];
  }
  
  for (const [key, url] of Object.entries(SERVICE_ICONS)) {
    if (slug.includes(key.replace(/-/g, '')) || key.includes(slug.replace(/-/g, ''))) {
      return url;
    }
  }
  
  if (slug.includes('plumb')) return SERVICE_ICONS['plumbing'];
  if (slug.includes('electric')) return SERVICE_ICONS['electrical'];
  if (slug.includes('ac') || slug.includes('air')) return SERVICE_ICONS['ac-repair'];
  if (slug.includes('clean')) return SERVICE_ICONS['deep-cleaning'];
  if (slug.includes('pest')) return SERVICE_ICONS['pest-control'];
  if (slug.includes('paint')) return SERVICE_ICONS['painting'];
  if (slug.includes('mov')) return SERVICE_ICONS['moving'];
  if (slug.includes('appliance')) return SERVICE_ICONS['appliance-repair-and-service'];
  
  return SERVICE_ICONS['plumbing'];
}

export default SERVICE_ICONS;
